import apiRoutes from 'services/apiRoutes';
import Axios from '../../apiConfig/Axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

const AccountActivationRequest = async (postOption: AccountActivationRequestType) => {
  const response = await Axios.post<GlobalApiResponseType<AccountActivationResultType>>(apiRoutes.AccountActivation.Post, postOption)
  return response.data;
}

export const useActivateAccount = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<AccountActivationResultType>,
      Error,
      AccountActivationRequestType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<AccountActivationResultType>,
    Error,
    AccountActivationRequestType
  >(['accountActivation'], AccountActivationRequest, option);
};